import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css";
import App from "./App";
import "./styles/style.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "../src/redux/store";
import "chart.js";
import { MasterProvider, useMaster } from "./Contexts/MasterContext";
import { EnvironmentProvider } from "./Contexts/EnvironmentContext";
import { CustomerProvider } from "./Contexts/CustomerContext";
import { AuthProvider } from "./Contexts/AuthContext";
import { ToastProvider } from "./Contexts/ToastContext";
// import DisableIfNotMaster from "./DisableIfNotMaster";

const isResizeObserverLoopError = (message: string) =>
  message === "ResizeObserver loop completed with undelivered notifications." ||
  message === "ResizeObserver loop limit exceeded";

const extractMessage = (input: unknown): string => {
  if (!input) {
    return "";
  }
  if (typeof input === "string") {
    return input;
  }
  if (typeof input === "object" && "message" in input && typeof (input as any).message === "string") {
    return (input as { message: string }).message;
  }
  return "";
};

if (typeof window !== "undefined") {
  const resizeObserverErrHandler = (event: ErrorEvent) => {
    const message = event.message || extractMessage(event.error) || "";
    if (isResizeObserverLoopError(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  const resizeObserverRejectionHandler = (event: PromiseRejectionEvent) => {
    const reason = extractMessage(event.reason);
    if (isResizeObserverLoopError(reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener("error", resizeObserverErrHandler, true);
  window.addEventListener(
    "unhandledrejection",
    resizeObserverRejectionHandler,
    true
  );
}

const RootGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isMaster = useMaster();

  return (
    <div className={isMaster.isMaster ? "" : "master-disabled"}>
      {children}
    </div>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ToastProvider>
    <AuthProvider>
      <CustomerProvider>
        <EnvironmentProvider>
          <MasterProvider>
            <RootGuard>
              <Provider store={store}>
                <App />
              </Provider>
            </RootGuard>
          </MasterProvider>
        </EnvironmentProvider>
      </CustomerProvider>
    </AuthProvider>
  </ToastProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
